import React, { useEffect, useRef, useState } from 'react';
import '../../assets/stepper.css';
import { useSelector } from 'react-redux';

const stepsConfig = ["Order Confirmed", "Shipped", "Out for Delivery", "Delivered"];

export default function Stepper({ orderId }) {

  const [currentStep, setCurrentStep] = useState(() => {
    const savedStep = localStorage.getItem(`currentStep_${orderId}`);
    return savedStep ? parseInt(savedStep) : 1;
  });
  const [status, setStatus] = useState([]);
  const [isComplete, setIsComplete] = useState(false);
  const [margins, setMargins] = useState({
    marginLeft: 0,
    marginRight: 0,
  });
  const stepRef = useRef([]);
  const CheckoutStateData = useSelector((state) => state.CheckoutStateData);

  useEffect(() => {
    const productStatus = CheckoutStateData.find((item) => item._id === orderId);
    if (productStatus) {
      setStatus(productStatus.orderStatus);
    }
  }, [CheckoutStateData, orderId]);

  useEffect(() => {
    setMargins({
      marginLeft: stepRef.current[0]?.offsetWidth / 2 || 0,
      marginRight: stepRef.current[stepsConfig.length - 1]?.offsetWidth / 2 || 0,
    });
  }, [stepRef, stepsConfig.length]);

  useEffect(() => {
    if (status.includes(stepsConfig[currentStep - 1])) {
      handleNext();
    }
  }, [status]);

  useEffect(() => {
    localStorage.setItem(`currentStep_${orderId}`, currentStep);
  }, [currentStep, orderId]);

  if (!stepsConfig.length) {
    return <></>;
  }

  const handleNext = () => {
    setCurrentStep((prevStep) => {
      if (prevStep === stepsConfig.length) {
        setIsComplete(true);
        return prevStep;
      } else {
        return prevStep + 1;
      }
    });
  };

  const calculateProgressBarWidth = () => {
    return ((currentStep - 1) / (stepsConfig.length - 1)) * 100;
  };

  return (
    <>
      <div className="stepper">
        {stepsConfig.map((step, index) => (
          <div
            key={step}
            ref={(el) => (stepRef.current[index] = el)}
            className={`step ${currentStep > index + 1 || isComplete ? "complete" : ""
              } ${currentStep === index + 1 ? "active" : ""}`}
          >
            <div className="step-number">
              {currentStep > index + 1 || isComplete ? (
                <span>&#10003;</span>
              ) : (
                index + 1
              )}
            </div>
            <div className="step-name">{step}</div>
          </div>
        ))}

        <div
          className="progress-bar"
          style={{
            width: `calc(100%-${margins.marginLeft + margins.marginRight}px)`,
            marginLeft: margins.marginLeft,
            marginRight: margins.marginRight,
          }}
        >
          <div
            className="progress"
            style={{ width: `${calculateProgressBarWidth()}%` }}
          ></div>
        </div>
      </div>
    </>
  );
}
